import { ButtonLink } from '@/legacy-src/components/ui/button'

type TextBannerProps = {
  readonly content: {
    subtitle: string
    title: string
    ButtonLink: {
      text: string
      style: string
      link: string
      withArrow: boolean
    }
  }
}

const TextBanner: React.FC<TextBannerProps> = ({ content }) => {
  return (
    <div className="rounded-2xl bg-secondary p-12 text-center tablet:p-20">
      <div className="text-base font-bold text-blue-500">{content.subtitle}</div>
      <div className="m-5 text-3xl font-semibold text-white">{content.title}</div>
      <ButtonLink href={content.ButtonLink.link} size="small">
        {content.ButtonLink.text}
      </ButtonLink>
    </div>
  )
}

export default TextBanner
